import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit7-introduction',
  templateUrl: './unit7-introduction.component.html',
  styleUrls: ['./unit7-introduction.component.css']
})
export class Unit7IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
